/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whywedo_Challenge2Inputs */

const ja_careers_whywedo_challenge2 = /** @type {(inputs: Careers_Whywedo_Challenge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`困難に立ち向かう`)
};

const en_careers_whywedo_challenge2 = /** @type {(inputs: Careers_Whywedo_Challenge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge interesting problems!`)
};

/**
* | output |
* | --- |
* | "Challenge interesting problems!" |
*
* @param {Careers_Whywedo_Challenge2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whywedo_challenge2 = /** @type {((inputs?: Careers_Whywedo_Challenge2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whywedo_Challenge2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whywedo_challenge2(inputs)
	return en_careers_whywedo_challenge2(inputs)
});
export { careers_whywedo_challenge2 as "careers_whyWeDo_challenge" }